/**
 * Removes options with the given department ids from a departments options tree at any depth.
 * Children of a removed option are hoisted into its position, so sub-departments stay selectable.
 * Kept free of runtime imports so it can be unit tested in Node.
 */
export function excludeDepartmentOptions(options, excludedIds) {
    const excludedIdsSet = new Set(Array.from(excludedIds, (id) => String(+id)));
    const excludeFrom = (branch) => {
        const result = [];
        branch.forEach((option) => {
            const children = option.children?.length ? excludeFrom(option.children) : undefined;
            if (excludedIdsSet.has(String(+option.value))) {
                if (children)
                    result.push(...children);
                return;
            }
            const keptOption = { ...option };
            delete keptOption.children;
            if (children?.length)
                keptOption.children = children;
            result.push(keptOption);
        });
        return result;
    };
    return excludeFrom(options || []);
}
